import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class CompanyService {
	private db;
	companies: FirebaseListObservable<Company[]>;

	constructor(private firebaseService: FirebaseService) {
		this.db = firebaseService.db;
		this.loadCompanies();
	}

	/**
	 * Load initial data
	 */
	loadCompanies() {
		window.dispatchEvent(new Event('loading'));
		this.companies = this.db.list('/company') as FirebaseListObservable<Company[]>
		this.companies.subscribe(data => {
			this.triggerDataChange();
		});

		return this.companies;
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	/**
	 * Get All Companies
	 */
	getCompanies() {
		return this.companies;
	}

	/**
	 * Get Company by ID
	 * @param {string} id: Item ID
	 */
	getCompany(id: string) {
		return this.db.object('/company/' + id) as FirebaseObjectObservable<Company>;
	}

	/**
	 * Add new Company
	 * @param {Company} company
	 */
	addCompany(company) {
		return this.companies.push(company);
	}

	/**
	 * Update Company Data
	 * @param {string} id  : Item ID
	 * @param {object} data: Updated data
	 */
	updateCompany(id: string, data: Company) {
		var company         = this.getCompany(id);
		    data.updated_at = (new Date()).getTime();
		return company.update(data);
	}

	/**
	 * Delete Company
	 * @param {string} id: Item ID
	 */
	deleteCompany(id: string) {
		var result = this.companies.remove(id);
		this.triggerDataChange();
		return result;
	}
}

export class Company {
	$key?   : string;
	name?   : string = '';
	street_one?   : string = '';
	street_two?   : string = '';
	city?   : string = '';
	postal_code?   : string = '';
	country_key?   : string = '';
	phone?  : string = '';
	fax?  : string = '';
	email?  : string = '';
	attn?  : string = '';
	type?  : string = '';
	
	created_at?: number;
	updated_at?: number;

	constructor() {
		var now             = new Date();
		    this.created_at = now.getTime();
		    this.updated_at = now.getTime();
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/company.service.ts